var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{staticClass:"ml-1 mr-1",attrs:{"type":_vm.primary,"size":_vm.size,"ghost":_vm.ghost,"icon":_vm.icon},on:{"click":function($event){return _vm.generateFile()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }